(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ljt-collection-main-assets"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ljtCollectionTemplateReady) return;
    window.ljtCollectionTemplateReady = true;

    const lockBody = (locked) => document.body.classList.toggle('ljt-collection-lock', locked);

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-ljt-open-filters]');
      if (openButton) {
        const root = openButton.closest('.ljt-collection');
        const dialog = root?.querySelector('[data-ljt-filter-dialog]');
        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
          lockBody(true);
        }
      }

      const closeButton = event.target.closest('[data-ljt-close-filters]');
      if (closeButton) {
        const dialog = closeButton.closest('[data-ljt-filter-dialog]');
        dialog?.close();
      }
    });

    document.addEventListener('click', (event) => {
      const dialog = event.target.closest('[data-ljt-filter-dialog]');
      if (dialog && event.target === dialog) dialog.close();
    });

    document.addEventListener('close', (event) => {
      if (event.target.matches('[data-ljt-filter-dialog]')) lockBody(false);
    }, true);

    document.addEventListener('change', (event) => {
      const field = event.target.closest('[data-ljt-auto-submit]');
      if (field?.form) field.form.submit();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
